"use client"

import { useId, useState } from "react"
import { ChevronDown } from "lucide-react"
import Text from "../../components/Text"

interface FAQItem {
  id: number
  question: string
  answer: string | React.ReactNode
}

export function FAQSection({ faqItems }: {faqItems: FAQItem[]}) {
  const [openId, setOpenId] = useState<number | null>(null)
  const uniqueID = useId();

  const toggleOpen = (id: number) => {
    setOpenId(openId === id ? null : id)
  }

  return (
    <div className="flex items-center justify-center px-4 my-12">
      <div className="w-full max-w-2xl">
        {/* Header Section */}
        <div className="text-center mb-12">
          {/* <Text type="highlighter" label={"FAQs"} /> */}
          <Text type="cardTitle" label={"Frequently Asked Questions"} cName="text-4xl font-bold text-foreground" />
        </div>

        {/* FAQ Items */}
        <div className="space-y-px">
          {faqItems.map((item) => (
            <div key={uniqueID+item.id} className="border-b border-border">
              <button
                onClick={() => toggleOpen(item.id)}
                className="w-full py-6 px-0 flex items-center justify-between text-left hover:bg-muted/50 transition-colors"
              >
                <Text label={item.question} cName="font-medium text-foreground" />
                <Text label={<ChevronDown className="w-5 h-5 text-muted-foreground" />} cName={`flex-shrink-0 ml-4 transition-transform duration-200 ${openId === item.id ? "rotate-180" : ""}`} />
              </button>

              {/* Expanded Answer */}
              {openId === item.id && <div className="pb-6 px-0 text-muted-foreground">
                {typeof(item.answer) === "string" ? <Text label={item.answer} type="description" /> : item.answer}
                </div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
